import { UPDATE_KEY_TERMS } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_KEY_TERMS:
      return { ...state, ...action.payload.entities.keyTerms };
    default:
      return state;
  }
};

export default reducer;
